import React from 'react'
import { ErrorReference } from '../../../../../../shared/error/error-reference'

// A node list that could not be read: what failed, the request's reference
// for support, and Try again.
export const ListError = ({ message, error, onRetry }) =>
  <div className="alert alert-danger m-2" role="alert" data-testid="list-error">
    <p className="mb-2">
      {message}
    </p>
    <ErrorReference error={error} />
    {onRetry &&
      <button type="button" className="btn btn-sm btn-outline-danger mt-2" onClick={onRetry}>
        Try again
      </button>}
  </div>
